import { Stack } from '@mui/material'
import { ClipboardText } from '@phosphor-icons/react'
import { tokens } from 'ComponentLibrary'
import { Typography } from 'ComponentLibrary/src/piazza'
import { TypographyProps } from 'ComponentLibrary/src/piazza/text/Typography/Typography'
import { defaults } from 'lodash'
import { ReactElement } from 'react'

type TaskType = 'todo'

type IconProps = { color?: string }

const LABEL_ICON_CONFIGURATION: Record<TaskType, { label: string; icon: (props: IconProps) => ReactElement }> = {
    todo: {
        label: 'TO DO',
        icon: ({ color = tokens.ColorIconInformative }: IconProps) => <ClipboardText size={16} color={color} weight="bold" />,
    },
}

type TaskTypeLabelWithIconProps = {
    taskType?: TaskType
    iconColor?: string
    typographyProps?: Partial<Pick<TypographyProps, 'variant' | 'color'>>
}

export function TaskTypeLabelWithIcon({ taskType = 'todo', typographyProps, iconColor }: TaskTypeLabelWithIconProps) {
    const { label, icon } = LABEL_ICON_CONFIGURATION[taskType]
    const typographyPropsWithDefaults = defaults({}, typographyProps, { variant: 'textM', color: tokens.ColorTextInformativeSubtle })
    return (
        <Stack gap={tokens.SizingSpacing075} alignItems="center" direction="row">
            {icon({ color: iconColor })}
            <Typography {...typographyPropsWithDefaults}>{label}</Typography>
        </Stack>
    )
}
